"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _antd = require("antd");

var _Input = _interopRequireDefault(require("../../components/Input"));

var _redux = require("../../redux"); // import app components


var GeneralSettings = function GeneralSettings(props) {
  var onChange = props.onChange,
      onUpdate = props.onUpdate,
      loading = props.loading;

  var _ref = (0, _redux.useAppSelector)(function (state) {
    return state;
  }),
      _ref$cms = _ref.cms,
      site = _ref$cms.site,
      editorSite = _ref$cms.editor.site;

  var handleChange = function handleChange(e) {
    return onChange(e.target.name, e.target.value);
  };

  var handleUpdate = function handleUpdate() {
    return onUpdate({
      title: editorSite === null || editorSite === void 0 ? void 0 : editorSite.title,
      siteUrl: editorSite === null || editorSite === void 0 ? void 0 : editorSite.siteUrl
    }, 'general');
  };

  return /*#__PURE__*/_react.default.createElement(_antd.Card, {
    title: "General"
  }, /*#__PURE__*/_react.default.createElement(_antd.Space, {
    direction: "vertical",
    size: 20
  }, /*#__PURE__*/_react.default.createElement(_Input.default, {
    label: "Title",
    value: editorSite === null || editorSite === void 0 ? void 0 : editorSite.title,
    name: "title",
    onChange: handleChange,
    disabled: !site
  }), /*#__PURE__*/_react.default.createElement(_Input.default, {
    label: "Frontend URL",
    value: editorSite === null || editorSite === void 0 ? void 0 : editorSite.siteUrl,
    name: "siteUrl",
    onChange: handleChange,
    disabled: !site
  }), /*#__PURE__*/_react.default.createElement(_antd.Button, {
    loading: loading === 'general',
    onClick: handleUpdate,
    children: "Update",
    type: "primary",
    disabled: !site
  })));
};

var _default = GeneralSettings;
exports.default = _default;